import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {ApiResponseModel} from '../shared/api-response.model';
import {Observable} from 'rxjs';
import {ApiVisa} from '../shared';

@Injectable({
  providedIn: 'root'
})
export class VoucherUploadCsvService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.CUSTOM_CELMONZE_URL_PREFIX + 'upload-csv';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.CUSTOM_CELMONZE_URL_PREFIX + 'upload-csv';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.CUSTOM_CELMONZE_URL_PREFIX + 'upload-csv';
    this.httpClient = http;
  }

}
